import { render } from "./CustomerStories.vue?vue&type=template&id=3ba7f927&scoped=true"
import script from "./CustomerStories.vue?vue&type=script&lang=js"
export * from "./CustomerStories.vue?vue&type=script&lang=js"

import "./CustomerStories.vue?vue&type=style&index=0&id=3ba7f927&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba7f927"]])

export default __exports__